//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Privilege',
  props: {
    validateResult: Boolean
  },
  methods: {
    click: function click() {
      if (this.validateResult) {
        this.$toast('您已完成校验,请耐心等待');
        return;
      }
      this.$emit('openPrivilege');
    }
  }
};